module.exports = __webpack_public_path__ + "img/lfb_home_pres.ee1eb7fa.webp";